'use client';

import { useEffect } from 'react';
import Column from '@/components/utilities/column/column';
import Container from '@/components/utilities/container/container';
import BookingFlowModuleList, {
  BookingFlowModule,
} from '@/components/utilities/content-modules/booking-flow-module-list/booking-flow-module-list';
import Row from '@/components/utilities/row/row';
import {
  trackPageLoadEvent,
  trackViewEvent,
} from '@/integrations/tracking/google-tag-manager/scripts';
import { tealiumView } from '@/integrations/tracking/tealium/scripts';
import styles from './my-trip-products-webview.module.scss';

export interface MyTripProductWebviewProps {
  /** Personalization data for the user */
  personalizationData?: Content.Properties.PersonalizationData;
  /** An array of the content modules to show */
  sections: Content.Components['BookingFlowSectionDto'][];
  /** Tracking data for the page */
  trackingData?: Content.Properties.TrackingData;
}

const MyTripProductWebview = ({
  personalizationData,
  sections,
  trackingData,
}: MyTripProductWebviewProps) => {
  useEffect(() => {
    trackPageLoadEvent({ content_group: 'my_trip_products_webview' });

    personalizationData && tealiumView(personalizationData);

    if (!trackingData?.gtmDataLayer) return;

    trackViewEvent(trackingData.gtmDataLayer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className={styles.component}>
      <Container>
        <Row>
          <Column>
            {sections.map((section, sectionIndex) => {
              return (
                <BookingFlowModuleList
                  key={sectionIndex}
                  contentModules={
                    section.contentModules as unknown as BookingFlowModule[]
                  }
                />
              );
            })}
          </Column>
        </Row>
      </Container>
    </div>
  );
};

MyTripProductWebview.displayName = 'MyTripProductWebview';

export default MyTripProductWebview;
